import { useLoaderData } from 'react-router';

import { useQuotation } from '~/api/quotations';
import { Redirect } from '~/components';
import { routes } from '~/providers/RouterProvider/router.routes';

import type { loader } from './EditQuotation.loader';

import { CreateEditQuotationForm } from './CreateEditQuotationForm';

export const EditQuotation = () => {
  const loaderData = useLoaderData<typeof loader>();
  const { data: quotation } = useQuotation(loaderData.id);

  if (!quotation || (quotation.status !== 'Sent' && quotation.status !== 'Expired')) return <Redirect to={routes.quotations} />;

  return <CreateEditQuotationForm mode="edit" quotation={quotation} />;
};
